/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Pr_Type_HeightInputs */

const fr_leaderboard_pr_type_height = /** @type {(inputs: Leaderboard_Pr_Type_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauteur`)
};

/**

* @param {Leaderboard_Pr_Type_HeightInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_pr_type_height = /** @type {((inputs?: Leaderboard_Pr_Type_HeightInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Pr_Type_HeightInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_pr_type_height(inputs)
});